import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import appSettingReducer from "./appsettingSlice";
import cartSlice from "./cartSlice";
import favoriteSlice from "./favoriteSlice";
import shareItemSlice from "./shareItemSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    appsetting: appSettingReducer,
    cart: cartSlice,
    favorite: favoriteSlice,
    shareItem: shareItemSlice,
  },
});
